import SettingsMetaData from "../../../../Components/Hooks/useSettingsMetaData";


const DurationTask = () => {
  return (
    <SettingsMetaData propertyName={"Duration_Task"} viewPropertyName={"Duration"} />
  );
};
export default DurationTask;